import { Content } from '@rematter/ui-web';

import { LoadBoard } from '../components/load-board/LoadBoard';
import { LoadBoardToolbar } from '../components/load-board/LoadBoardToolbar';

import { TransportationRootLayout } from '~/modules/transportation/layouts/TransportationRootLayout';

export const LoadBoardView = () => (
  <TransportationRootLayout className="@LoadBoardView">
    <LoadBoardToolbar />
    <Content>
      <LoadBoard />
    </Content>
  </TransportationRootLayout>
);
